// Единый источник текстов для подсказок у полей форм и карточек
//
// Если нужен новый текст, добавь его в этот config и передай ключ в поле
//
// Сейчас config умеют читать:
// - BaseFormField
// - BaseLabel
// - BaseInfoField
// - BaseParticipantCard через объект поля
//
// Пример для BaseFormField:
// <BaseFormField label="Название груза" info-key="order.cargo" />
//
// Пример для BaseLabel:
// <base-label info-key="order.customer">Заказчик</base-label>
//
// Пример для BaseInfoField:
// <BaseInfoField label="ИНН:" :value="counterparty.inn" info-key="counterparty.common" />
//
// Пример для BaseParticipantCard:
// { label: "Номер:", value: vehicle.registration_number, infoKey: "vehicle.common" }
export const fieldInfo = {
  communication: {
    cover: "JPEG, PNG или WebP, до 10 МБ. Для обложки рекомендуем 1200×800 пикселей и до 500 КБ.",
    image: "JPEG, PNG или WebP, до 10 МБ. Рекомендуем ширину 1200–1600 пикселей и до 500 КБ.",
  },
  common:
    "Используется в ЭДО. Рекомендуется заполнить, чтобы значение пробрасывалось в документы ЭДО.",
  order: {
    cargo:
      "Используется в ЭДО. Рекомендуется заполнить, чтобы значение пробрасывалось в документы ЭДО.",
    payment: "Используется в ЭДО для условий оплаты.",
    comment: "Используется в ЭДО как комментарий к документу.",
    customer: "Используется для ЭДО как сторона, которая заказала перевозку",
    shipper: "Используется для ЭДО как сторона, которая передает груз к перевозке",
    carrier: "Используется для ЭДО как сторона, которая выполняет перевозку",
    consignee: "Используется для ЭДО как сторона, которая принимает груз после перевозки",
  },
  cargo: {
    title: "Используется в ЭДО как наименование груза.",
    quantity:
      "Используется в ЭДО как количество грузовых мест.",
    weight:
      "Используется в ЭДО как масса груза. Масса брутто обязательна для ЭТрН.",
    grossWeight:
      "Используется в ЭДО как общая масса брутто позиции груза.",
    unitWeight:
      "Вес одного грузового места. Используется для автоподсчёта массы брутто.",
    dimensions:
      "Используется в ЭДО для описания габаритов и объёма груза.",
    volume:
      "Объём одного грузового места. Для ЭДО общий объём считается с учётом количества мест.",
  },
  counterparty: {
    common:
      "Используется в ЭДО. Рекомендуется заполнить, чтобы значение пробрасывалось в документы ЭДО.",
    address: "Используется в ЭДО как адрес участника.",
  },
  routePoint: {
    common: "Используется для заполнения ЭДО",
  },
  driver: {
    common:
      "Используется в ЭДО. Рекомендуется заполнить, чтобы значение пробрасывалось в документы ЭДО.",
    license:
      "Используется в ЭДО как данные водительского удостоверения. Рекомендуется заполнить, чтобы значение пробрасывалось в документы ЭДО.",
  },
  vehicle: {
    common:
      "Используется в ЭДО. Рекомендуется заполнить, чтобы значение пробрасывалось в документы ЭДО.",
    ownershipDocument:
      "Используется в ЭДО как документ-основание владения ТС.",
  },
};

export function fieldInfoByKey(key) {
  if (!key) return "";

  return key.split(".").reduce((value, part) => value?.[part], fieldInfo) || "";
}
